module.exports = __webpack_public_path__ + "static/media/top_square3.6dc8c5bb.svg";